import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'MG',
  text: 'Llevaba años sintiéndome agotada por una compañera de trabajo. El Módulo 3 fue revelador. Por primera vez entendí qué me pasaba realmente cada vez que hablábamos.',
  name: 'Marcela G.',
  city: 'Córdoba'
}, {
  initials: 'LP',
  text: 'Probé muchos libros de autoayuda. Este es distinto. Es práctico, claro y se nota que está pensado para aplicarlo de verdad. Lo recomiendo a todos mis amigos.',
  name: 'Laura P.',
  city: 'Rosario'
}, {
  initials: 'RM',
  text: 'El bonus de las 50 frases me salvó. Tengo un jefe muy difícil y antes me iba del trabajo agotada. Hoy salgo con la cabeza intacta.',
  name: 'Romina M.',
  city: 'Buenos Aires'
}];
export function QuickTestimonials() {
  return <section className="w-full bg-bg-soft py-14 md:py-20 px-4 border-y border-line" data-id="element-333">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-5" data-id="element-334">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.08,
        duration: 0.5
      }} className="bg-white border border-line rounded-3xl p-6 shadow-sm" data-id="element-335">
            <div className="flex items-center gap-3 mb-3" data-id="element-336">
              <div className="w-11 h-11 rounded-full bg-rose text-white flex items-center justify-center font-bold font-serif text-sm" data-id="element-337">
                {t.initials}
              </div>
              <div className="flex gap-0.5" data-id="element-338">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-4 h-4 fill-rose text-rose" data-id="element-339" />)}
              </div>
            </div>
            <p className="font-serif-italic text-ink leading-relaxed text-base mb-4" data-id="element-340">
              "{t.text}"
            </p>
            <div className="text-sm font-semibold text-ink" data-id="element-341">
              {t.name}{' '}
              <span className="text-muted font-normal" data-id="element-342">— {t.city}</span>
            </div>
          </motion.div>)}
      </div>
    </section>;
}